import React from "react";
import { Modal } from "react-responsive-modal";
import {
  TitleProduct,
  SubTitleProduct,
  MiddleContainer,
} from "../../components/modal/style/ConfirmationModalStyle";

import { Flex } from "../../styles/GlobalStyle";
import ButtonComponent from "../Button";
import LoadingIcon from "../LoadingIcon";
import Property from "../../model/property";
import { withTranslation } from "react-i18next";

const ConfirmationFulfillmentModal = ({
  content,
  showConfirmation,
  openCloseModal,
  onConfirm,
  autoReplyText,
  loading,
  okDisabled,
  t,
  confirmOrderTitle = null,
}) => {
  return (
    <Modal
      open={showConfirmation}
      onClose={() => {
        openCloseModal(!showConfirmation);
        const html = document.querySelector("html");
        html.style = "";
      }}
      showCloseIcon={false}
      center>
      <ModalContent
        onCancel={() => openCloseModal(!showConfirmation)}
        onConfirm={onConfirm}
        content={content}
        autoReplyText={autoReplyText}
        okDisabled={okDisabled}
        confirmOrderTitle={confirmOrderTitle}
        t={t}
      />
      <LoadingIcon loadingState={loading} />
    </Modal>
  );
};

export default withTranslation()(ConfirmationFulfillmentModal);

function ModalContent({
  onConfirm,
  onCancel,
  content,
  autoReplyText,
  okDisabled,
  t,
  confirmOrderTitle = null,
}) {
  const preset = Property.getPreset();
  return (
    <MiddleContainer>
      <Flex
        flex={1}
        justifyContent={"center"}>
        <TitleProduct className={"modalTitle"}>
          {confirmOrderTitle || t("CONFIRM_ORDER")}
        </TitleProduct>
        <hr />
        <SubTitleProduct className={"modalSubtitle"}>{content}</SubTitleProduct>
        <SubTitleProduct className={"modalSubtitle"}>
          {autoReplyText}
        </SubTitleProduct>
        <Flex
          container
          flex={1}
          alignItems={"center"}
          justifyContent={"center"}>
          <ButtonComponent
            padding={"0.25em 0"}
            width={"80%"}
            label={t("CONFIRM")}
            backgroundColor={
              preset.app_home_color_primary
                ? preset.app_home_color_primary
                : "black"
            }
            color={preset.text_color}
            borderRadius={"30px"}
            onClick={onConfirm}
            disabled={okDisabled}
          />
        </Flex>
        <Flex
          container
          flex={1}
          alignItems={"center"}
          justifyContent={"center"}>
          <ButtonComponent
            padding={"0.25em 0"}
            width={"80%"}
            label={t("CANCEL")}
            backgroundColor={
              preset.app_home_color_primary
                ? preset.app_home_color_primary
                : "black"
            }
            color={preset.text_color}
            borderRadius={"30px"}
            onClick={onCancel}
          />
        </Flex>
      </Flex>
    </MiddleContainer>
  );
}
